import React from "react";
import { Avatar as MuiAvatar } from "@mui/material";
import { AVATAR_COLORS } from "../../types";

import { API_BASE_URL } from "../../api/apiClient";
import { useAppSelector } from "../../store/hooks";

interface AvatarProps {
  initials: string;
  color?: string;
  size?: number;
  src?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  initials,
  color = "blue",
  size = 32,
  src,
}) => {
  const employees = useAppSelector((state: any) => state.data?.employees || []);

  // Attempt to resolve src globally if not provided, based on initials and color
  let resolvedSrc = src;
  if (!resolvedSrc && initials) {
    const matched = employees.find((e: any) => e.initials === initials && (e.avColor === color || color === "blue"));
    if (matched && matched.profilePic) {
      resolvedSrc = matched.profilePic;
    }
  }

  const imgSrc = resolvedSrc
    ? resolvedSrc.startsWith("http") || resolvedSrc.startsWith("data:")
      ? resolvedSrc
      : `${API_BASE_URL.replace("/api", "")}${resolvedSrc}`
    : undefined;

  return (
    <MuiAvatar
      src={imgSrc}
      sx={{
        width: size,
        height: size,
        background: AVATAR_COLORS[color] || AVATAR_COLORS.blue,
        fontSize: size * 0.35,
        fontWeight: 700,
        flexShrink: 0,
        // Force initials to always render fully uppercase, regardless of
        // how the initials string was cased upstream (e.g. "Jb" -> "JB").
        textTransform: "uppercase",
      }}
    >
      {!imgSrc && initials?.toUpperCase()}
    </MuiAvatar>
  );
};

export default Avatar;